// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__O9css","itemTitle":"ClientEmergencyInfo_itemTitle__3D6Op","itemText":"ClientEmergencyInfo_itemText__1hgul"};